import { AlertTriangle, CheckCircle2, MapPin } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { FileGallery } from "@/components/FileGallery";
import { fmtDateTime, pointUrl } from "@/lib/helpers";
import { t } from "@/lib/i18n";

export function IssuesList({ issues, files, onResolved, admin = false, lang = "ro" }) {
  if (!issues.length) return null;
  const resolve = async (id) => {
    try {
      await api.put(`/issues/${id}/resolve`);
      onResolved?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-3" data-testid="issues-list">
      {issues.map((i) => (
        <div key={i.id} data-testid={`issue-${i.id}`} className={`rounded-xl border p-4 ${i.resolved ? "border-white/10 bg-white/[0.02]" : "border-red-500/40 bg-red-500/[0.07]"}`}>
          <div className="flex items-center gap-2">
            <AlertTriangle className={`h-4 w-4 ${i.resolved ? "text-slate-500" : "text-red-400"}`} />
            <span className="font-semibold">{t(lang, `issue_${i.type}`)}</span>
            <span className="ml-auto font-mono text-[11px] text-slate-400">{fmtDateTime(i.created_at)}</span>
          </div>
          {i.note && <p className="mt-2 whitespace-pre-wrap text-sm text-slate-200">{i.note}</p>}
          <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-slate-400">
            <span>{i.driver_name}</span>
            {i.lat != null && (
              <a href={pointUrl(i.lat, i.lng)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-400 hover:underline"><MapPin className="h-3 w-3" />GPS</a>
            )}
            <span className={i.resolved ? "text-emerald-400" : "text-red-300"}>{i.resolved ? t(lang, "resolved") : t(lang, "open")}</span>
          </div>
          {i.photo_ids?.length > 0 && (
            <div className="mt-3"><FileGallery files={files.filter((f) => i.photo_ids.includes(f.id))} empty="" /></div>
          )}
          {admin && !i.resolved && (
            <button type="button" onClick={() => resolve(i.id)} data-testid={`resolve-issue-${i.id}`} className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-emerald-500/40 px-3 py-1.5 text-xs text-emerald-300 hover:bg-emerald-500/10">
              <CheckCircle2 className="h-3.5 w-3.5" /> Marchează rezolvat
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
